import { lazy } from '@cobliteam/lazy-with-retries';

import { Location } from '@cobliteam/common-types';

const InsuranceContainer = lazy(
  () => import('@cobliteam/insurance/src/containers')
);

const routes = [
  {
    path: Location.INSURANCE,
    component: InsuranceContainer,
    accessDeniedDescription: 'contratar seguros com a Cobli',
  },
];

export default routes;
